import ReactDOM from "react-dom/client";

import "./index.css";
import { Provider } from "react-redux";
import App from "./App";
import store from "./components/store/index";
import { BrowserRouter } from "react-router-dom";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);
